import { ReactNode } from 'react';

import { Box, LayoutCard, Stack } from '@cast/design-system';

type Props = {
  title: ReactNode;
  /** Rendered inline with the title in a wrapping row (e.g. a small chip/badge). */
  titleAdornment?: ReactNode;
  /** Rendered in the header end slot (right side), e.g. an info note or alert badge. */
  note?: ReactNode;
  primaryMetricsEl: ReactNode;
  secondaryMetricsEl?: ReactNode;
  chartEl: ReactNode;
  testId?: string;
};

export const ChartWidget = ({
  title,
  titleAdornment,
  note,
  primaryMetricsEl,
  secondaryMetricsEl,
  chartEl,
  testId,
}: Props) => {
  const titleEl = titleAdornment ? (
    <Stack direction="row" gap={8} alignItems="center" flexWrap="wrap">
      {title}
      {titleAdornment}
    </Stack>
  ) : (
    title
  );

  return (
    <LayoutCard
      title={titleEl}
      headerEndContent={note}
      headerDivider
      padding={false}
      testId={testId}
      sx={{ height: '100%', pb: 16 }}
      slotProps={{
        header: {
          sx: { p: 12 },
        },
        content: {
          sx: { display: 'flex', flexDirection: 'column' },
        },
      }}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        px={16}
        pt={16}
        pb={16}
        gap={16}
      >
        {primaryMetricsEl}

        {secondaryMetricsEl}
      </Stack>
      <Box px={16} flex={1}>
        {chartEl}
      </Box>
    </LayoutCard>
  );
};
